"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class; /* eslint-disable react/prop-types */

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _components = require("components");

var _utils = require("../../utils");

var _subscriptions = require("redux/modules/subscriptions");

var _payments = require("redux/modules/payments");

var _customer = require("redux/modules/customer");

var _CheckoutLayout = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/CheckoutLayout");

var _CheckoutLayout2 = _interopRequireDefault(_CheckoutLayout);

var _CheckoutPriceBox = require("@quixeltools/quixel-ui-library/dist/components/megascans/checkout/CheckoutPriceBox");

var _CheckoutPriceBox2 = _interopRequireDefault(_CheckoutPriceBox);

var _CheckoutStickyHeader = require("@quixeltools/quixel-ui-library/dist/components/megascans/checkout/CheckoutStickyHeader");

var _CheckoutStickyHeader2 = _interopRequireDefault(_CheckoutStickyHeader);

var _SiteHeaderGap = require("@quixeltools/quixel-ui-library/dist/components/common/website/SiteHeaderGap");

var _SiteHeaderGap2 = _interopRequireDefault(_SiteHeaderGap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemsPointsByPlan = _ramda2.default.converge(_ramda2.default.compose(_ramda2.default.filter(_ramda2.default.complement(_ramda2.default.isNil)), _ramda2.default.unapply(_ramda2.default.identity)), [_ramda2.default.cond([[_ramda2.default.propEq("license", "hobby"), _ramda2.default.always("Hobby license")], [_ramda2.default.propEq("license", "freelancer"), _ramda2.default.always("Freelancer license")], [_ramda2.default.propEq("license", "indie"), _ramda2.default.always("Indie license")]]), _ramda2.default.cond([[_ramda2.default.propEq("resolution", 2048), _ramda2.default.always("2K max resolution")], [_ramda2.default.propEq("resolution", 4096), _ramda2.default.always("4K max resolution")], [_ramda2.default.propEq("resolution", 4097), _ramda2.default.always("4K max resolution")], [_ramda2.default.propEq("resolution", 8196), _ramda2.default.always("8K max resolution")], [_ramda2.default.propEq("resolution", 8197), _ramda2.default.always("8K max resolution")]])]);

var getConsolidatedPoints = function getConsolidatedPoints(plan, plansDecorated, seatsForSubscription) {
  //const planDetails = R.nth(R.findIndex(R.propEq('license', plan.license))(plansDecorated))(plansDecorated);
  var itemPoints = ["Megascans, Mixer & Bridge"]; //R.propOr([], 'marketingPoints', planDetails);

  var billingSubText = "year";

  if (plan.billing === "annual") {
    billingSubText = "year";
  } else if (plan.billing === "monthly") {
    billingSubText = "month";
  } else if (plan.billing === "quarterly") {
    billingSubText = "3 months";
  } else if (plan.billing === "biannual") {
    billingSubText = "6 months";
  }

  var paidSubText = "year";

  if (plan.billing === "annual") {
    paidSubText = "yearly";
  } else if (plan.billing === "monthly") {
    paidSubText = "monthly";
  } else if (plan.billing === "quarterly") {
    paidSubText = "quarterly";
  } else if (plan.billing === "biannual") {
    paidSubText = "bi-annually";
  }

  if (seatsForSubscription) {
    itemPoints = itemPoints.filter(function (point) {
      return point.indexOf("max resolution") > -1 ? point.indexOf("-") === -1 ? true : false : true;
    });
    itemPoints = _ramda2.default.concat(["License for " + seatsForSubscription + " seats", plan.accessResolutionName + " max resolution", plan.points + " points/" + billingSubText], itemPoints);
  } else if (plan.license === "freelancer" && plan.accessResolutionName === "4k") {
    itemPoints.splice(2, 0, plan.accessResolutionName + " max resolution, " + plan.points + " points/" + billingSubText);
    itemPoints.splice(2, 0, "Paid " + paidSubText);
  } else if (plan.license === "freelancer" && plan.accessResolutionName === "8k") {
    itemPoints.splice(2, 0, plan.accessResolutionName + " max resolution, " + plan.points + " points/" + billingSubText);
    itemPoints.splice(2, 0, "Paid " + paidSubText);
  } else {
    itemPoints.splice(2, 0, plan.accessResolutionName + " max resolution, " + plan.points + " points/" + billingSubText);
    itemPoints.splice(2, 0, "Paid " + paidSubText);
  }

  return itemPoints;
};

var subscriptionActions = {
  hasSubscriptionPlans: _subscriptions.hasSubscriptionPlans,
  getSubscriptionPlans: _subscriptions.getSubscriptionPlans,
  buySubscription: _subscriptions.buySubscription
};

var Subscribe = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        plan = _ref.params.plan;

    // Get customer data first
    return dispatch((0, _customer.getCustomer)()).then(function () {
      if (!(0, _subscriptions.hasSubscriptionPlans)(getState())) {
        return dispatch((0, _subscriptions.getSubscriptionPlans)()).then(function (plans) {
          if (!plans.find(function (thisPlan) {
            return thisPlan.type === plan;
          })) {
            throw new Error("Plan to subscribe to not found");
          }
        });
      }

      return _bluebird2.default.try(function () {
        var plans = getState().subscriptions.plans;

        if (!plans.find(function (thisPlan) {
          return thisPlan.type === plan;
        })) {
          throw new Error("Plan to subscribe to not found");
        }
      });
    });
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    plans: state.subscriptions.subPlans,
    plansDecorated: state.subscriptions.plansDecorated,
    subscriptions: state.subscriptions,
    userEmail: state.user.email,
    price: state.payments.price,
    currentPayment: state.payments.currentPayment,
    customer: state.customer.customer,
    projectName: state.subscriptions.projectNameForSubscription,
    projectDetails: state.subscriptions.projectDetailsForSubscription,
    seats: state.subscriptions.seatsForSubscription
  };
}, (0, _extends3.default)({}, subscriptionActions, { getPrice: _payments.getPrice, setPaymentItem: _payments.setPaymentItem, resetPromocodeValidation: _payments.resetPromocodeValidation })), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(Subscribe, _React$Component);

  function Subscribe(props) {
    (0, _classCallCheck3.default)(this, Subscribe);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Subscribe.__proto__ || (0, _getPrototypeOf2.default)(Subscribe)).call(this, props));

    _this.state = {
      isProduction: (0, _utils.getEviormentType)()
    };
    return _this;
  }

  (0, _createClass3.default)(Subscribe, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var plan = this.getCurrentPlan();
      this.props.setPaymentItem(plan);
      this.props.resetPromocodeValidation();
      this.setState({
        isProduction: (0, _utils.getEviormentType)()
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var flag = true,
          elem = document.getElementById("checkout-price"),
          scrollTo = void 0;
      elem = document.getElementById("checkout-price");

      scrollTo = elem.parentNode.clientHeight - elem.clientHeight + 77;
      elem.style.width = "22.3%";
      elem.style.maxWidth = "320px";
      if (window.scrollY + 60 > scrollTo) {
        elem.style.position = "absolute";
        if (flag === true) {
          elem.style.top = scrollTo + "px";
          flag = false;
        }
      } else if (window.scrollY + 60 <= scrollTo) {
        if (elem.getBoundingClientRect().top + 35 - window.scrollY < 0) {
          elem.style.width = "22.3%";
          elem.style.top = "60px";
          elem.style.position = "fixed";
          flag = true;
        } else {
          elem.style.width = "unset";
          elem.style.top = "unset";
          elem.style.position = "unset";
        }
      }
      window.onscroll = function () {
        elem = document.getElementById("checkout-price");

        if (elem) {
          scrollTo = elem.parentNode.clientHeight - elem.clientHeight + 77;
          elem.style.width = "22.3%";
          elem.style.maxWidth = "320px";
          if (window.scrollY + 60 > scrollTo) {
            elem.style.position = "absolute";
            if (flag === true) {
              elem.style.top = scrollTo + "px";
              flag = false;
            }
          } else if (window.scrollY + 60 <= scrollTo) {
            if (elem.getBoundingClientRect().top + 35 - window.scrollY < 0) {
              elem.style.width = "22.3%";
              elem.style.top = "60px";
              elem.style.position = "fixed";
              flag = true;
            } else {
              elem.style.width = "unset";
              elem.style.top = "unset";
              elem.style.position = "unset";
            }
          }
        }
      };
    }
  }, {
    key: "getCurrentPlan",
    value: function getCurrentPlan() {
      var _props = this.props,
          allPlans = _props.plans,
          planType = _props.params.plan;


      return allPlans.find(function (plan) {
        return plan.type === planType;
      });
    }
  }, {
    key: "canGoBack",
    value: function canGoBack() {
      var currentPlan = this.getCurrentPlan();
      return _ramda2.default.compose(_ramda2.default.lt(1), _ramda2.default.length, _ramda2.default.filter(_ramda2.default.propEq("license", currentPlan.license)))(this.props.plans);
    }
  }, {
    key: "renderPriceBox",
    value: function renderPriceBox() {
      var _props2 = this.props,
          price = _props2.price,
          currentPayment = _props2.currentPayment,
          seatsForSubscription = _props2.subscriptions.seatsForSubscription;

      var plan = this.getCurrentPlan();

      var name = "Megascans " + plan.name;
      var planPrice = plan.amount;
      var itemPoints = getConsolidatedPoints(plan, this.props.plansDecorated, seatsForSubscription);

      var actualPrice = planPrice;
      var _actualPrice = planPrice;
      var _discountedPrice = price.price ? price.price : 0;
      var _discount = 0;

      if (plan.discount) {
        _discount = plan.discount;
        _actualPrice = actualPrice + _discount;

        if (currentPayment && currentPayment.promoCode && currentPayment.promoCode.discount) {
          _discount = currentPayment.promoCode.discountValue + _discount;
        }
      } else {
        if (currentPayment && currentPayment.promoCode && currentPayment.promoCode.discount) {
          _discount = currentPayment.promoCode.discountValue;
        }
      }

      // let monthlyPrice = plan.amount;
      var seatPrice = plan.amount;

      // if(plan.billing == "annual")
      // {
      //   let plans = this.props.plans;
      //
      //   for(let i =0; i < plans.length; i++)
      //   {
      //     let thePlan = plans[i];
      //     if(thePlan.name == plan.name && thePlan.billing == "monthly")
      //     {
      //       monthlyPrice = thePlan.amount;
      //       break;
      //     }
      //   }
      //   seatPrice = monthlyPrice * 12;
      //   actualPrice = seatsForSubscription ? seatsForSubscription * seatPrice : seatPrice;
      //
      //   anualDiscount = +(((actualPrice - planPrice) / actualPrice) * 100).toFixed(0);
      // }
      //

      // let discount = plan.discount;
      // let orignalPrice=planPrice+(discount?discount:0);
      // if(plan.planType === 'personal' && plan.billing === 'annual')
      //   discount=(discount+120);
      // let discountedPrice = R.propOr(planPrice, 'price', price);
      // if (currentPayment && currentPayment.promoCode && currentPayment.promoCode.discount) {
      //   discount =  currentPayment.promoCode.discountedPrice;
      //   // discount = orignalPrice ;
      //   discountedPrice = orignalPrice - discount;
      // }

      return _react2.default.createElement(_CheckoutPriceBox2.default, {
        itemName: name,
        itemPoints: itemPoints,
        itemPrice: _actualPrice,
        total: _discountedPrice,
        discount: parseFloat(_discount).toFixed(2)
        // subTotalPrice={seatsForSubscription ? (discountedPrice ? (seatsForSubscription * discountedPrice) : planPrice) : (discountedPrice || planPrice)}
        , taxPrice: _ramda2.default.propOr(0, "vatAmount", price),
        loadingPrice: price.loading,
        seats: seatsForSubscription,
        planName: "Quixel " + plan.name,
        seatPrice: seatPrice,
        isAnnualBilling: plan.billing === "annual"

        // footNote={plan.billing === 'annual' ? '* Billed yearly' : '* Billed monthly'}
      });
    }
  }, {
    key: "renderStickyBar",
    value: function renderStickyBar() {
      var _props3 = this.props,
          price = _props3.price,
          currentPayment = _props3.currentPayment,
          seatsForSubscription = _props3.subscriptions.seatsForSubscription;

      var plan = this.getCurrentPlan();

      var name = "Megascans " + plan.name;
      var planPrice = seatsForSubscription ? seatsForSubscription * plan.amount : plan.amount;
      var itemPoints = getConsolidatedPoints(plan, this.props.plansDecorated, seatsForSubscription);

      var actualPrice = planPrice;
      var anualDiscount = 25;
      var monthlyPrice = plan.amount;
      var seatPrice = plan.amount;
      if (plan.billing == "annual") {
        var plans = this.props.plans;

        for (var i = 0; i < plans.length; i++) {
          var thePlan = plans[i];
          if (thePlan.name == plan.name && thePlan.billing == "monthly") {
            monthlyPrice = thePlan.amount;
            break;
          }
        }
        seatPrice = monthlyPrice * 12;
        actualPrice = seatsForSubscription ? seatsForSubscription * seatPrice : seatPrice;

        anualDiscount = +((actualPrice - planPrice) / actualPrice * 100).toFixed(0);
      }

      var discount = 0;
      var discountedPrice = undefined;
      if (currentPayment && currentPayment.promoCode && currentPayment.promoCode.discount) {
        discount = currentPayment.promoCode.discount;
        discountedPrice = currentPayment.promoCode.discountedPrice;
      }

      return _react2.default.createElement(_CheckoutStickyHeader2.default, {
        itemName: name,
        itemPoints: itemPoints,
        total: _ramda2.default.propOr(planPrice, "price", price),
        itemPrice: _ramda2.default.propOr(planPrice, "price", price) + parseInt(plan.discount ? plan.discount : 0),
        discount: parseInt(plan.discount ? plan.discount : 0),
        subTotalPrice: seatsForSubscription ? discountedPrice ? seatsForSubscription * discountedPrice : planPrice : discountedPrice || planPrice,
        taxPrice: _ramda2.default.propOr(0, "vatAmount", price),
        loadingPrice: price.loading,
        seats: seatsForSubscription,
        planName: plan.name,
        seatPrice: seatPrice,
        isAnnualBilling: plan.billing === "annual",
        footNote: plan.billing === "annual" ? "* Billed yearly" : "* Billed monthly"
      });
    }
  }, {
    key: "renderPaymentWizard",
    value: function renderPaymentWizard() {
      var _props4 = this.props,
          currentPayment = _props4.currentPayment,
          subscription = _props4.subscription;
      var _props$subscriptions = this.props.subscriptions,
          seatsForSubscription = _props$subscriptions.seatsForSubscription,
          projectNameForSubscription = _props$subscriptions.projectNameForSubscription,
          projectDetailsForSubscription = _props$subscriptions.projectDetailsForSubscription;

      var currentPlan = this.getCurrentPlan();

      var amount = seatsForSubscription ? seatsForSubscription * currentPlan.amount : currentPlan.amount;
      var discountValue = undefined;
      var discountedPrice = undefined;
      if (currentPayment && currentPayment.promoCode && currentPayment.promoCode.discount) {
        discountValue = currentPayment.promoCode.discountValues;
        discountedPrice = currentPayment.promoCode.discountedPrice;
      }

      var hasActiveSubscription = (0, _utils.isActiveSubscriber)({ subscription: subscription });
      var transactionType = hasActiveSubscription ? "switch-plan" : "subscription-plan";

      return _react2.default.createElement(
        "div",
        { style: { marginTop: "3em" } },
        _react2.default.createElement(_components.PaymentWizard, {
          amount: amount,
          discountValue: discountValue,
          discountedPrice: discountedPrice,
          currency: "USD",
          paymentSuccessTo: "/megascans/library/home",
          backLink: this.canGoBack() ? "/choose/" + currentPlan.planType : null,
          paymentItem: currentPlan,
          transactionType: transactionType,
          paymentActionCreator: (0, _subscriptions.buySubscription)({
            planId: currentPlan.type,
            multiSeat: currentPlan.multiSeat,
            seats: seatsForSubscription,
            projectName: projectNameForSubscription,
            projectDetails: projectDetailsForSubscription,
            promocode: currentPayment.promoCode && currentPayment.promoCode.promoCode,
            signedPromocodeInstance: currentPayment.promoCode && currentPayment.promoCode.signedPromocodeInstance
          })
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props$currentPayment = this.props.currentPayment,
          done = _props$currentPayment.done,
          paymentItem = _props$currentPayment.paymentItem;

      var subTitle = done && paymentItem ? "You are now a member of the Quixel Community. We hope you'll create amazing things with your Quixel subscription." : "Please double check everything before you proceed.";

      var price = this.props.price;


      var currentPlan = this.getCurrentPlan();
      var planPrice = currentPlan.amount;
      var saleAmount = _ramda2.default.propOr(planPrice, "price", price);

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_SiteHeaderGap2.default, null),
        _react2.default.createElement(_CheckoutLayout2.default, {
          headerIconSrc: "/quixel_logo.png",
          title: done ? "Thank you!" : "Checkout",
          subTitle: subTitle,
          form: this.renderPaymentWizard(),
          sidebarOnDesktop: this.renderPriceBox(),
          stickyBarOnMobile: this.renderStickyBar()
        })
      );
    }
  }]);
  return Subscribe;
}(_react2.default.Component)) || _class) || _class);
exports.default = Subscribe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Subscribe/Subscribe.jsx
// module id = 2604
// module chunks = 0